import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VeiculoSensor } from "src/app/models/VeiculoSensor.model";
import { VwSensor } from "src/app/models/VwSensor.model";
import { EventEmitterSensorService } from "src/app/services/event-emitter-sensor.service";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId, findIncompleteSensorRows, alertIncompleteTpmsRows } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-two-simple",
  templateUrl: "./axle-two-simple.component.html",
  styleUrls: ["./axle-two-simple.component.scss"],
})
export class AxleTwoSimpleComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() sensoresDisponiveis: any;
  @Input() veiculoId: number;

  @Output() atualizarSensores = new EventEmitter<void>();

  public sensorTwoLeftSelect: any = [];
  public sensorTwoRightSelect: any = [];

  public sensorTwoRightCombo: any = [];
  public sensorTwoLeftCombo: any = [];

  public axisTwoSimpleLeftForm: FormGroup;
  public axisTwoSimpleRightForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private serviceApiBase: ApiBaseService,
    private componentResetService: EventEmitterSensorService
  ) {}

  ngOnInit(): void {
    this.componentResetService.reiniciarComponentes$.subscribe(async (a) => {
      this.sensoresDisponiveis = null;
      this.veiculoSensores = null;
      this.sensorTwoRightCombo = [];
      this.sensorTwoLeftCombo = [];

      const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

      const eixo = await this.serviceApiBase.get<any>({
        url: new VeiculoSensor()["nomeConsultaApiBase"] + this.veiculoId,
      });

      this.veiculoSensores = eixo["content"] ?? [];

      const sensor = await this.serviceApiBase.get<any>({
        url:
          new VwSensor()["nomeConsultaApiBaseSensor"] +
          this.veiculoId +
          "/perfil/" +
          perfil,
      });

      this.sensoresDisponiveis = sensor;

      if (this.sensoresDisponiveis.length > 0) {
        this.sensoresDisponiveis.forEach((element) => {
          this.sensorTwoRightCombo.push(element);
          this.sensorTwoLeftCombo.push(element);
        });
      }

      this.loadSensor();
    });

    this.axisTwoSimpleLeftForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisTwoSimpleRightForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    if (this.sensoresDisponiveis.length > 0) {
      this.sensoresDisponiveis.forEach((element) => {
        this.sensorTwoRightCombo.push(element);
        this.sensorTwoLeftCombo.push(element);
      });
    }

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisTwoSimpleLeftForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 2 ESQ"
      );
      this.axisTwoSimpleRightForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 2 DIR"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo2Direito = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          38
        );
        const eixo2Esquerdo = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          37
        );

        // EIXO 2 DIREITO
        if (eixo2Direito != null) {
          this.axisTwoSimpleRightForm.controls["id"].setValue(eixo2Direito.id);

          if (eixo2Direito.sensor != null) {
            appendSensorToCombo(this.sensorTwoRightCombo, eixo2Direito.sensor);
            this.sensorTwoRightSelect = eixo2Direito.sensor.id;
          }

          if (eixo2Direito.pneu != null) {
            this.axisTwoSimpleRightForm.controls["pneu"].setValue(
              eixo2Direito.pneu.numeroFogo
            );
          }

          this.axisTwoSimpleRightForm.controls["nrPressaoMinima"].setValue(
            eixo2Direito.nrPressaoMinima
          );

          this.axisTwoSimpleRightForm.controls["nrPressaoMaxima"].setValue(
            eixo2Direito[0].nrPressaoMaxima
          );

          this.axisTwoSimpleRightForm.controls["nrTemperaturaMaxima"].setValue(
            eixo2Direito[0].nrTemperaturaMaxima
          );
        }

        // EIXO 2 ESQUERDO
        if (eixo2Esquerdo != null) {
          this.axisTwoSimpleLeftForm.controls["id"].setValue(eixo2Esquerdo.id);

          if (eixo2Esquerdo.sensor != null) {
            appendSensorToCombo(this.sensorTwoLeftCombo, eixo2Esquerdo.sensor);
            this.sensorTwoLeftSelect = eixo2Esquerdo.sensor.id;
          }

          if (eixo2Esquerdo.pneu != null) {
            this.axisTwoSimpleLeftForm.controls["pneu"].setValue(
              eixo2Esquerdo.pneu.numeroFogo
            );
          }

          this.axisTwoSimpleLeftForm.controls["nrPressaoMinima"].setValue(
            eixo2Esquerdo.nrPressaoMinima
          );

          this.axisTwoSimpleLeftForm.controls["nrPressaoMaxima"].setValue(
            eixo2Esquerdo.nrPressaoMaxima
          );

          this.axisTwoSimpleLeftForm.controls["nrTemperaturaMaxima"].setValue(
            eixo2Esquerdo.nrTemperaturaMaxima
          );
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public async submitFormDelete(form: FormGroup): Promise<void> {
    this.spinner.show();
    try {
      const values = form.value;
      var post;

      post = {
        veiculo: {
          id: this.veiculoId,
        },
        nrPressaoMinima: values.nrPressaoMinima,
        nrPressaoMaxima: values.nrPressaoMaxima,
        nrTemperaturaMaxima: values.nrTemperaturaMaxima,
        sensor: {
          id: values.cdSensor,
        },
        pneu: null,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      console.log(post);

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        values.id,
        new VeiculoSensor()["nomeConsultaApiBaseRemove"],
        post
      );

      form.get("cdSensor").setValue("");
      form.get("id").setValue("");

      this.spinner.hide();

      this.handleDelete();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      //this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitFormDeleteAll(): Promise<void> {
    this.spinner.show();
    try {
      var estepeArray: any = [];
      var posicoesPneusList: any = [];

      estepeArray.push(this.axisTwoSimpleRightForm.value);
      estepeArray.push(this.axisTwoSimpleLeftForm.value);

      if (estepeArray.length > 0) {
        estepeArray.forEach((element) => {
          var posicaoPneuResquest = {
            cdPosicaoPneu: element.cdPosicaoPneu,
          };
          posicoesPneusList.push(posicaoPneuResquest);
        });
      }

      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseRemoveAll"],
        post
      );

      this.axisTwoSimpleRightForm.get("cdSensor").setValue("");
      this.axisTwoSimpleRightForm.get("id").setValue("");
      this.axisTwoSimpleLeftForm.get("cdSensor").setValue("");
      this.axisTwoSimpleLeftForm.get("id").setValue("");

      this.spinner.hide();

      this.handleDeleteAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitFormAddAll(): Promise<void> {
    var estepeArray: any = [];

      estepeArray.push(this.axisTwoSimpleRightForm.value);
      estepeArray.push(this.axisTwoSimpleLeftForm.value);

    const posicoesIncompletas = findIncompleteSensorRows(estepeArray);
    if (posicoesIncompletas.length > 0) {
      await alertIncompleteTpmsRows(posicoesIncompletas);
      return;
    }

    if (estepeArray.length > 0 && this.verificarDuplicados(estepeArray)) {
      this.handleItensDuplicados();
      return;
    }

    var posicoesPneusList: any = [];

    estepeArray.forEach((element) => {
      if (element.cdSensor != "") {
        var posicaoPneuResquest = {
          cdPosicaoPneu: element.cdPosicaoPneu,
          cdSensor: element.cdSensor,
          pneu: element.pneu,
          nrPressaoMinima: element.nrPressaoMinima,
          nrPressaoMaxima: element.nrPressaoMaxima,
          nrTemperaturaMaxima: element.nrTemperaturaMaxima,
          idPerfil: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
        posicoesPneusList.push(posicaoPneuResquest);
      }
    });

    if (posicoesPneusList.length === 0) {
      return;
    }

    this.spinner.show();
    try {
      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseAddAll"],
        post
      );

      this.spinner.hide();

      this.handleAddAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }


  verificarDuplicados(axisOneArray: any[]): boolean {
    const seen = new Set();
    for (const item of axisOneArray) {
      if (seen.has(item.cdSensor)) {
        return true; // Retorna true se encontrar um valor duplicado
      } else {
        seen.add(item.cdSensor);
      }
    }
    return false; // Retorna false se não houver valores duplicados
  }

  public async handleItensDuplicados(): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Sensores selecionados estão com duplicidade, por favor corrigir!",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleAddAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 2 vinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDeleteAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 2 desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDelete(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensor desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }
}
